import React from 'react';
import { cn } from './lib/utils';

/* Port of `~co/common/form` Layout — `data-type` = default (stacked,
   medium gaps, labels/titles ignored by gap rules) | grid (2-col
   label+control settings grid) | columns (two equal columns).
   Styles are unlayered in global.css (.ui-layout) — the child-spacing
   selectors key on data-is-label/data-is-title. */
export function Layout({ className, type, as = 'div', ...props }) {
  const Comp = as;
  return (
    <Comp
      {...props}
      className={cn('ui-layout', className)}
      data-type={type || 'default'}
    />
  );
}
